export default __webpack_public_path__ + "static/media/shipped_black.58fc167f.svg";